module.exports = __webpack_public_path__ + "img/logo_b_mini.9fc39481.png";